import React, { useState, useEffect } from 'react';
import { usePackagingOperationsContext } from '../context/PackagingOperationsContext';
import { useMsal } from '@azure/msal-react';
import { SP_MSAL_SCOPE, buildSharePointListItemsUrl } from '../../../../constants/sharepoint';

const ReverifyComponent: React.FC = () => {
    const {  dispatch } = usePackagingOperationsContext();
    const { instance, accounts } = useMsal();
    const [qaOptions, setQaOptions] = useState<string[]>([]);
    const [verifiedBy, setVerifiedBy] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            if (accounts.length === 0) return;
            setLoading(true);
            try {
                const tokenResponse = await instance.acquireTokenSilent({
                    scopes: [SP_MSAL_SCOPE],
                    account: accounts[0]
                });
                
                const url = buildSharePointListItemsUrl('EmployeeList', '$select=Title,EmployeeName/Title&$expand=EmployeeName');
                const response = await fetch(url, {
                    headers: {
                        'Authorization': `Bearer ${tokenResponse.accessToken}`,
                        'Accept': 'application/json;odata=verbose'
                    }
                });
                
                if (response.ok) {
                    const data = await response.json();
                    const employees = data.d.results.map((r: any) => r.EmployeeName?.Title || r.Title).filter(Boolean);
                    const uniqueNames = Array.from(new Set(employees)) as string[];
                    uniqueNames.sort();
                    setQaOptions(uniqueNames);
                    
                    if (accounts[0].name && uniqueNames.includes(accounts[0].name)) {
                        setVerifiedBy(accounts[0].name);
                    } else if (uniqueNames.length > 0) {
                        setVerifiedBy(uniqueNames[0]);
                    }
                }
            } catch (err) {
                console.error("Error fetching QA users from EmployeeList", err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, [instance, accounts]);

    const handleSubmit = () => {
        dispatch({ type: 'SET_STATE', payload: 'COMPLETED' });
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-sky-200 mt-4">
            <div className="bg-sky-100 px-4 py-3 border-b border-sky-200 rounded-t-lg">
                <h2 className="text-lg font-semibold text-sky-800">Re-Verification Clearance</h2>
            </div>
            <div className="p-4 space-y-4">
                <p className="text-sm text-gray-700">Review the Corrective Actions taken by Production above. If everything is clear, verify and close the checklist.</p>
                
                <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Verified By (QA)</label>
                    <select 
                        className="block w-full max-w-sm rounded-md border-gray-300 shadow-sm focus:border-sky-500 focus:ring-sky-500 sm:text-sm p-2 border"
                        value={verifiedBy}
                        onChange={(e) => setVerifiedBy(e.target.value)}
                        disabled={loading}
                    >
                        {loading && <option value="">Loading users...</option>}
                        {!loading && qaOptions.length === 0 && <option value="">No users found</option>}
                        {qaOptions.map(qa => (
                            <option key={qa} value={qa}>{qa}</option>
                        ))}
                    </select>
                </div>

                <div className="text-right mt-4">
                    <button
                        onClick={handleSubmit}
                        disabled={loading || !verifiedBy}
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:opacity-50"
                    >
                        Close & Close Checklist
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReverifyComponent;
